import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-light-wiki",
  "use": "icon-light-wiki-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-light-wiki\"><path d=\"M2.237 2.5a1 1 0 0 1 1-1h13a5 5 0 0 1 5 5v15a1 1 0 0 1-1 1H7.372a5.24 5.24 0 0 1-3.63-1.447 4.849 4.849 0 0 1-1.505-3.494V2.5Z\" fill=\"#336DF4\" /><path d=\"M2.237 7h10.5a3.5 3.5 0 0 1 3.5 3.5v12h-9a5 5 0 0 1-5-5V7Z\" fill=\"#3EC3F7\" /><path d=\"M2.237 12.5h7a2 2 0 0 1 2 2v8h-4a5 5 0 0 1-5-5v-5Z\" fill=\"#95E599\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol